import Icon from "@components/Icon";
import { addOpacityToColor, colours } from "@helpers";
import { mixpanelTrack } from "@helpers/mixpanel.helper";
import React from "react";
import styled from "styled-components";

const SliderDiv = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  margin-bottom: ${(props) =>
		props.marginBottom && props.marginBottom.mobile
			? props.marginBottom.mobile
			: "56px"};

  @media (min-width: 860px) {
    margin-bottom: ${(props) =>
			props.marginBottom && props.marginBottom.desktop
				? props.marginBottom.desktop
				: "56px"};
  }

  > div:first-child > div {
    border-top-left-radius: 12px;
    border-bottom-left-radius: 12px;
  }
  > div:last-child > div {
    border-top-right-radius: 12px;
    border-bottom-right-radius: 12px;
  }
`;

const Sliders = styled.div`
  display: flex;
  flex-direction: row;
  gap: 2px;
  background: ${colours.LIGHT_GREY};
`;

const SlidersButtons = styled.label`
  flex: 1;
  background-color: ${(props) =>
		props.selected ? colours.WHITE : "transparent"};
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  user-select: none;
  height: 56px;
  min-width: 154px;
  width: max-content;
  transition: background-color 0.3s ease, border-color 0.3s ease,
    box-shadow 0.3s ease;

  border: 2px solid
    ${(props) => (props.selected ? colours.PEACH : "transparent")};
  box-shadow: 0 0 0.75rem
    ${(props) =>
			props.selected
				? addOpacityToColor(colours.MIDNIGHT_BLUE, 0.11)
				: "transparent"};
  padding: 10px;
  border-radius: 12px;

  @media (min-width: 860px) {
    height: 52px;
    min-width: 218px;
    padding: 0 30px;
  }

  &:hover {
    border-radius: 12px;
    background-color: ${(props) =>
			props.selected
				? colours.WHITE
				: addOpacityToColor(colours.MIDNIGHT_BLUE, 0.05)};
  }

  &:active {
    background-color: ${(props) =>
			props.selected
				? colours.WHITE
				: addOpacityToColor(colours.MIDNIGHT_BLUE, 0.08)};
  }

  &:focus-within {
    outline: 2px solid #0066FF;
    outline-offset: 2px;
    position: relative;
    z-index: 1;
  }
`;

const RadioInput = styled.input`
  position: absolute;
  opacity: 0;
  cursor: pointer;
  height: 56px;
  width: 154px;
  @media (min-width: 860px) {
    height: 52px;
    width: 218px;
  }
`;

const IconContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 8px;
  @media (min-width: 860px) {
    margin-right: 16px;
  }

  i {
    ::before {
      cursor: pointer;
    }
  }
`;

const SliderOption = ({
	active,
	handleRadioChange,
	sliderItems,
	marginBottom = { mobile: "56px", desktop: "56px" },
	page_name = "",
	cta_position = "",
}) => {
	return (
		<>
			<SliderDiv marginBottom={marginBottom}>
				{sliderItems.map((sliderItem, index) => (
					<div key={index}>
						<Sliders>
							<SlidersButtons
								selected={active === index}
								htmlFor={index.toString()}
							>
								<RadioInput
									type="radio"
									checked={active === index}
									id={index.toString()}
									value={sliderItem.value}
									onChange={handleRadioChange}
									onClick={() =>
										mixpanelTrack("cta_sim_clicked", {
											page_name,
											cta_position,
											cta_name: sliderItem.value,
										})
									}
								/>

								<IconContainer>
									<Icon
										iconName={sliderItem.iconName}
										iconSizes={{
											iconMobile: 24,
											iconTablet: 24,
											iconLaptop: 28,
											iconDesktop: 28,
											iconDesktopLarge: 28,
										}}
										alt={sliderItem.name}
									/>
								</IconContainer>
								<p>{sliderItem.name}</p>
							</SlidersButtons>
						</Sliders>
					</div>
				))}
			</SliderDiv>
		</>
	);
};

export default SliderOption;
